import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { ErrorBoundary } from '../components/shared/ErrorBoundary';
import { BodyPointerEventsGuard } from '../components/shared/BodyPointerEventsGuard';
import { NotFoundPage } from '../components/shared/NotFoundPage';
import { Loading } from '@/kit';
import { SaleNotificationsBridge } from '@/domains/sales/notifications/SaleNotificationsBridge';
import { PermissionsBridge } from '../components/permissions/PermissionsBridge';
import type { useAuthStore } from '../stores/authStore';

export interface AppRouterContext {
    auth: {
        ensureLoaded: () => ReturnType<ReturnType<typeof useAuthStore.getState>['ensureLoaded']>;
    };
}

export const Route = createRootRouteWithContext<AppRouterContext>()({
    // Sin TanStack Router Devtools: el badge flotante (logo en gradiente) aparecía en todas las
    // pantallas, incluido el login, y no es parte del diseño del mock.
    component: () => (
        <ErrorBoundary>
            <BodyPointerEventsGuard />
            {/* Acá y no en un portal: es el único punto que no se desmonta al navegar, así el socket
                vive toda la sesión en vez de reabrirse en cada pantalla. */}
            <SaleNotificationsBridge />
            {/* Alimenta usePermissions() y el <Gate> del kit con los permisos de useAuth en toda la app. */}
            <PermissionsBridge>
                <Outlet />
            </PermissionsBridge>
        </ErrorBoundary>
    ),
    notFoundComponent: NotFoundPage,
    pendingComponent: () => <Loading size="lg" fullScreen />,
});
